import * as d3 from 'd3'

const margin = { top: 0, right: 30, bottom: 0, left: 10 }

export default function(svg, width, height, data, percentage, color) {
  const getAxes = data => {
    const x = d3
      .scaleLinear()
      .domain([0, d3.max(data, d => d.value)])
      .range([margin.left, width - margin.right])

    const y = d3
      .scaleBand()
      .domain(data.map(d => d.name))
      .range([margin.top, height - margin.bottom])
      .padding(0.1)

    const xAxisDraw = g =>
      g
        .attr('transform', `translate(0,${margin.top})`)
        .call(d3.axisTop(x).ticks(0))
        .call(g => g.select('.domain').remove())

    const yAxisDraw = g =>
      g.attr('transform', `translate(${margin.left},0)`).call(
        d3
          .axisLeft(y)
          .tickFormat('')
          .tickSizeOuter(0)
      )

    return { x, y, xAxisDraw, yAxisDraw }
  }

  const xAxis = svg.append('g')
  const yAxis = svg.append('g')

  const { x, y, xAxisDraw, yAxisDraw } = getAxes(data)

  const rectsG = svg.append('g').attr('fill', color ? color : '#900')

  rectsG
    .selectAll('rect')
    .data(data)
    .join('rect')
    .attr('x', x(0))
    .attr('y', d => y(d.name))
    .attr('width', 0)
    .attr('height', y.bandwidth())

  const labelsG = svg
    .append('g')
    .attr('fill', 'white')
    .attr('text-anchor', 'end')
    .style('font-size', '12px')

  labelsG
    .selectAll('text')
    .data(data)
    .join('text')
    .attr('x', 0)

  const yearsG = svg
    .append('g')
    .attr('fill', 'white')
    .attr('text-anchor', 'start')
    .style('font-size', '12px')

  yearsG
    .selectAll('text')
    .data(data)
    .join('text')
    .attr('x', 12)
    .attr('y', d => y(d.name) + y.bandwidth() / 2)
    .attr('dy', '0.35em')
    .text(function(d) {
      return d.name
    })

  const renderData = data => {
    const { x, y } = getAxes(data)

    xAxis.transition().call(xAxisDraw)
    yAxis.transition().call(yAxisDraw)

    rectsG
      .selectAll('rect')
      .data(data)
      .join('rect')
      .transition()
      .duration(500)
      .attr('x', x(0))
      .attr('y', d => y(d.name))
      .attr('width', d => x(d.value) - x(0))
      .attr('height', y.bandwidth())

    labelsG
      .selectAll('text')
      .data(data)
      .join('text')
      .transition()
      .duration(500)
      .attr('x', d => x(d.value) - 4)
      .attr('y', d => y(d.name) + y.bandwidth() / 2)
      .attr('dy', '0.35em')
      .text(function(d) {
        var formatted_num = percentage
          ? String(d3.format('.2s')(d.value) + '%')
          : String(d3.format('.2s')(d.value))
        return formatted_num
      })

    yearsG
      .selectAll('text')
      .data(data)
      .join('text')
      .transition()
      .duration(500)
      .attr('y', d => y(d.name) + y.bandwidth() / 2)
      .attr('dy', '0.35em')
      .text(function(d) {
        return d.name
      })
  }

  return renderData
}
